<!-- Hero Section (Full Width) -->
<div class="position-relative w-100 overflow-hidden">
  <div>
    <div class="position-relative w-100 overflow-hidden">
      <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>
      <!-- Placeholder Hero Image -->
      <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/dAHaHqv5Vh4rep3hHMCJThFaF4d8EQyNxYSmnL3w.jpg"
        alt="Hero Image" class="img-fluid w-100" />
      <!-- <div
        class="position-absolute top-0 w-100 h-100 d-flex flex-column justify-content-center w-25 text-start px-3 px-md-5">
        <h1 class="headingBL title mb-3 text-white">
          High-Performance <br />All-in-One PCs for Labs & Offices
        </h1>
      </div> -->
    </div>
  </div>
</div>

<!-- 5 Images Row -->
<div class="container-fluid pt-4 pt-md-5 pb-4 px-2 px-md-5" style="background-color: #000000;">
  <div class="row g-2">
    <div class="col-6 col-md">
      <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/rAtIwkFaLKl44TMRG09DBEa3Owt66yX5qrdM9hE5.jpg"
        class="img-fluid rounded shadow-sm clickable-image gallery-img" alt="Smartroom Banner"
        (click)="openImagePopup('https://d3uop73ba1wtqg.cloudfront.net/uploads/rAtIwkFaLKl44TMRG09DBEa3Owt66yX5qrdM9hE5.jpg')">
    </div>
    <div class="col-6 col-md">
      <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/KXBkrLG2cb0QHO01c5cQKa6O5x8IaEYXSWo7cCCz.jpg"
        class="img-fluid rounded shadow-sm clickable-image gallery-img" alt="Side Web"
        (click)="openImagePopup('https://d3uop73ba1wtqg.cloudfront.net/uploads/KXBkrLG2cb0QHO01c5cQKa6O5x8IaEYXSWo7cCCz.jpg')">
    </div>
    <div class="col-6 col-md">
      <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/dtSDw8yDjXXtZ7VOlM8xAkACUbKbIVFqvccuuUqO.jpg"
        class="img-fluid rounded shadow-sm clickable-image gallery-img" alt="Website"
        (click)="openImagePopup('https://d3uop73ba1wtqg.cloudfront.net/uploads/dtSDw8yDjXXtZ7VOlM8xAkACUbKbIVFqvccuuUqO.jpg')">
    </div>
    <div class="col-6 col-md">
      <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/vSyQ1yIXTSI6gYgPjyi3xhriaRN0jwuWeov9FFzb.jpg"
        class="img-fluid rounded shadow-sm clickable-image gallery-img" alt="Panel"
        (click)="openImagePopup('https://d3uop73ba1wtqg.cloudfront.net/uploads/vSyQ1yIXTSI6gYgPjyi3xhriaRN0jwuWeov9FFzb.jpg')">
    </div>
    <div class="col-6 col-md">
      <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/NHSdC3fBEzZkGzkvQuVGPb1VFh8CtXClP5rua5Y9.jpg"
        class="img-fluid rounded shadow-sm clickable-image gallery-img" alt="All in One PAC"
        (click)="openImagePopup('https://d3uop73ba1wtqg.cloudfront.net/uploads/NHSdC3fBEzZkGzkvQuVGPb1VFh8CtXClP5rua5Y9.jpg')">
    </div>
  </div>
</div>

<!-- PC Configurations Section -->
<section class="icon-features-section">
  <div class="container mb-5">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">All-in-One PC <span>Configurations</span></h2>
      <div class="title-underline"></div>
    </div>

    <div class="icon-features-grid">
      <div class="feature-item" *ngFor="let config of pcConfigurations">
        <div class="icon-box">
          <mat-icon>{{ config.icon }}</mat-icon>
          <div class="icon-bg"></div>
        </div>
        <h4 class="feature-title">{{ config.title }}</h4>
        <p class="feature-desc">{{ config.description }}</p>
      </div>
    </div>
  </div>
</section>



<!-- Specifications Section -->
<div class="specifications-section">
  <div class="container mb-5">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">Technical <span>Specifications</span></h2>
      <div class="title-underline"></div>
    </div>
    <mat-tab-group dynamicHeight>
      <mat-tab *ngFor="let section of specSections" [label]="section.label">
        <div class="spec-table-wrapper mt-4">
          <app-spec-table [headerLabel]="section.headerLabel" [columns]="section.columns" [rows]="section.rows">
          </app-spec-table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<!-- CTA Section -->
<section class="cta-section text-center">
  <div class="container mb-5 cta-buttons">
    <a routerLink="/form/contactUs" class="btn-cta btn-cta-primary">
      <mat-icon>request_quote</mat-icon>
      Inquire
    </a>
  </div>
</section>

<!-- Image Popup Modal -->
<div class="image-popup-overlay" *ngIf="selectedImage" (click)="closeImagePopup()">
  <div class="image-popup-content">
    <button class="close-button" (click)="closeImagePopup()">
      <mat-icon>clear</mat-icon>
    </button>
    <img [src]="selectedImage" alt="Full size image" class="popup-image">
  </div>
</div>